export const leaderboardMessages = {
  'zh-CN': {
    title: '练级地图排行',
    allLevels: '全部', minutes: '{count} 分钟',
    sampleAccumulation: '同一玩家在同一地图、等级段和数据来源下的多段记录可累计形成样本。查询全部等级时，各等级段独立计算和展示。',
    level: '等级', position: '排名', status: '状态', collectingTab: '积累中', formalTab: '正式榜', sourceFilter: '来源',
    hourlyExp: '经验/小时', hourlyReference: '参考经验/小时', records: '共 {count} 条',
    sourceSamples: '数据来源', allSourcesShort: '全部', collapse: '收起详情', closeDetails: '收起 {name} 的详情',
    exp: '经验效率', perHour: '经验 / 小时', typical: '排行依据', samples: '参与数据',
    filters: '筛选', filterTitle: '筛选地图', reset: '重置筛选', done: '查看结果',
    rules: '统计规则', details: '地图详情', openDetails: '查看 {name} 的详情',
    scope: '{level} · {job} · {source}', count: '{count} 张地图',
    page: '第 {current} / {total} 页', previous: '上一页', next: '下一页',
    scale: '本页效率对比', sorted: '按中间水平排序', collecting: '数据积累中',
    moreUsers: '还差 {count} 位玩家', moreMinutes: '还差 {count} 分钟', met: '已满足',
    usersProgress: '参与人数', timeProgress: '有效时长', sampleRule: '正式榜条件',
    uploadRule: '枫记上传条件',
    uploadEligibility: '同一地图、同一等级段（每 5 级一档），单段有效经验记录满 {minutes} 分钟且有经验收益，即可上传。不同片段不拼接凑时长。',
    uploadTiming: '结束记录后自动上传达标片段。中途暂停或掉线，已达标的片段仍会保留。',
    qualificationHelp: '数据不足的地图会显示在“积累中”。',
    distribution: '不同玩家的经验效率', source: '数据来源', updated: '最近更新',
    median: '中间水平', low: '较低水平', high: '较高水平', upper: '高效水平',
    medianHelp: '按玩家每小时经验的“中间水平”排名，只计入有效记录。',
    rangeHelp: '约一半玩家处于“较低水平”到“较高水平”之间。“高效水平”接近前 10%，不是最高纪录。',
    empty: '这里还没有地图', emptyHint: '调整等级、职业或来源，看看其他地图。',
    error: '暂时无法获取排行', refreshFailed: '更新失败，保留上次结果。',
    reference: '参考效率', pending: '等待榜单更新',
  },
  en: {
    title: 'Leveling map rankings',
    allLevels: 'All', minutes: '{count} minutes',
    sampleAccumulation: 'A player’s records on the same map, in the same level range and from the same source can accumulate into one sample. All-level rankings calculate and display each level range separately.',
    level: 'Level', position: 'Rank', status: 'Status', collectingTab: 'Collecting', formalTab: 'Official', sourceFilter: 'Source',
    hourlyExp: 'EXP/hour', hourlyReference: 'Reference EXP/hour', records: '{count} records',
    sourceSamples: 'Data sources', allSourcesShort: 'All', collapse: 'Collapse details', closeDetails: 'Close details for {name}',
    exp: 'EXP efficiency', perHour: 'EXP / hour', typical: 'How rankings are calculated', samples: 'Contributing data',
    filters: 'Filters', filterTitle: 'Filter maps', reset: 'Reset filters', done: 'View results',
    rules: 'Ranking rules', details: 'Map details', openDetails: 'View details for {name}',
    scope: '{level} · {job} · {source}', count: '{count} maps',
    page: 'Page {current} / {total}', previous: 'Previous page', next: 'Next page',
    scale: 'This page comparison', sorted: 'Sorted by the middle pace', collecting: 'Collecting data',
    moreUsers: '1 more player | {count} more players', moreMinutes: '1 more minute | {count} more minutes', met: 'Met',
    usersProgress: 'Players', timeProgress: 'Valid time', sampleRule: 'Official ranking requirements',
    uploadRule: 'Maple Log upload requirements',
    uploadEligibility: 'Each segment needs {minutes} minutes of valid EXP data and a positive EXP gain on the same map and within the same five-level range. Separate segments are not combined.',
    uploadTiming: 'Eligible segments upload automatically when you end the session. Pauses or disconnections do not discard segments that already qualify.',
    qualificationHelp: 'Maps needing more data appear under Collecting.',
    distribution: 'EXP rates across players', source: 'Data sources', updated: 'Last updated',
    median: 'Middle pace', low: 'Lower pace', high: 'Higher pace', upper: 'Fast pace',
    medianHelp: 'Maps are ranked by the middle EXP/hour result across players. Only valid records count.',
    rangeHelp: 'About half of players fall between the Lower and Higher pace. Fast pace is near the top 10%, not the record high.',
    empty: 'No maps here yet', emptyHint: 'Try a different level range, job, or source.',
    error: 'Rankings could not be loaded', refreshFailed: 'Refresh failed. Previous results are still shown.',
    reference: 'Reference efficiency', pending: 'Awaiting ranking update',
  },
}
